module.exports = __webpack_public_path__ + "static/img/icon_help.cc26bcc4.png";